export const supplierOriginActionsTypes = {
  GET_SUPPLIERS_ORIGIN: 'GET_SUPPLIERS_ORIGIN',
  GET_SUPPLIERS_ORIGIN_EXITO: 'GET_SUPPLIERS_ORIGIN_EXITO',
  GET_SUPPLIERS_ORIGIN_ERRROR: 'GET_SUPPLIERS_ORIGIN_ERRROR'
}
